import React, { useState } from 'react'
import { Button, Col, Row } from 'reactstrap';
import Select from 'react-select';
import { GlobalSearchAdmission } from './GlobalSearchAdmission';
import { useHistory } from 'react-router-dom';


export const IndexHeader = (props) => {



    const {

        // * MOVILE CONFIGURATION
        rightPanelOpen,
        setRightPanelOpen,

        // * CONTROL ACTIONS
        id_printer_point,
        listPrinterPoint,
        handleSelectValuesWorkOrder,
        PlaceHolderOption,
        handleChangeTypeClient,
        checkTypeClient,
        handleChangePatient,
        handleChangeDoctor,
        id_company,
        handleChangeClient,
        idAgreementCompany,
        handleChangeAgreement,
        id_work_order_type_service,
        isEditWorkOrder,

        // * INFORMATION LISTS
        listCompanies,
        listAgreements,
        validHopitalInterfaced,
        listType,

        // * LOCAL STORAGE
        _service,

        // * STYLES
        customSelectStyles,
        idDoctorSelect,
        handleSelectExamChange,

        // * UPLOAD
        url_helen,
        buap,

        // * GLOBAL SEARCH
        handleCreateDoctor,
        handleCreatePatient,
        id_patient,
        _config_dashboard,
        validate_actions,
        allExams,
        loadingEditWorkOrder,
        customSelectStyles1,



    } = props
    const history = useHistory();

    const [showMobileFilters, setShowMobileFilters] = useState(false);

    const mobileTypeConfig = {

        1: {
            icon: "icofont icofont-user-alt-5 f-16",
            title: "Particular"
        },

        2: {
            icon: "icofont icofont-users-social f-16",
            title: "Muestreo"
        },

        3: {
            icon: "icofont icofont-industries-alt-4 f-16",
            title: "Empresa"
        }

    };

    const currentMobileType =
        mobileTypeConfig[checkTypeClient]
        || mobileTypeConfig[1];

    const totalButtons = [
        true,
        (url_helen !== buap && checkTypeClient !== 2),
        (url_helen === buap && checkTypeClient !== 3)
    ].filter(Boolean).length;

    const mobileCol = totalButtons === 2 ? "col-6" : "col-4";

    return (
        <>
            <Row className="pos-header-row align-items-center">                {
                !isEditWorkOrder && <Col xs="12" lg="auto" className="d-flex gap-2 header-block header-buttons">
                    <Button
                        size="sm"
                        onClick={() => handleChangeTypeClient(1)}
                        className={`pos-pill ${checkTypeClient === 1 ? "active" : ""}`}
                    >
                        <i className="icofont icofont-user-alt-5 f-16"></i>
                        &nbsp; Particular
                    </Button>
                    {
                        (url_helen !== buap && checkTypeClient !== 2) && (
                            <Button
                                size="sm"
                                onClick={() => handleChangeTypeClient(3)}
                                className={`pos-pill ${checkTypeClient === 3 ? "active" : ""}`}
                            >
                                <i className="icofont icofont-industries-alt-4 f-16"></i>
                                &nbsp; Empresa
                            </Button>
                        )
                    }
                    {
                        // * CONFUGURATION UPLOAD MASIVE
                    }
                    {
                        (url_helen === buap && checkTypeClient !== 3) && <Button
                            size="sm"
                            onClick={() => handleChangeTypeClient(2)}
                            className={`pos-pill ${checkTypeClient === 2 ? "active" : ""}`}
                        >
                            <i className="icofont icofont-users-social f-16"></i>
                            &nbsp; Muestreo
                        </Button>

                    }
                </Col>
            }
                {
                    isEditWorkOrder && (
                        <Col xs="12" lg="auto" className="d-flex align-items-center gap-3 header-block header-buttons">

                            <Button
                                size="sm"
                                className={`pos-pill active`}
                                style={{ cursor: "default", fontSize: "12px" }}
                                disabled={loadingEditWorkOrder}
                            >
                                <i className="icofont icofont-user-alt-5 f-16"></i>
                                &nbsp; {checkTypeClient === 1 ? "Particular" : "Empresa"}

                            </Button>

                            <div className="wo-mini-actions">

                                <button
                                    className="wo-mini-btn back"
                                    onClick={() => history.goBack()}
                                    title="Regresar"
                                    disabled={loadingEditWorkOrder}

                                >
                                    <i className="pi pi-arrow-left"></i>
                                </button>


                            </div>

                        </Col>
                    )
                }
                <Col xs="12" lg className="px-2 header-block header-search">
                    <div className="input-group-dark">
                        {validHopitalInterfaced === "True" &&
                            <div className="select-container">
                                <Select
                                    classNamePrefix="select"
                                    name="id_work_order_type_service"
                                    value={id_work_order_type_service}
                                    options={listType}
                                    placeholder={PlaceHolderOption}
                                    onChange={(e) => handleSelectValuesWorkOrder(e, "id_work_order_type_service")}
                                    isClearable={true}
                                    isDisabled={(isEditWorkOrder && _service !== "True") ? true : false}
                                    styles={customSelectStyles}
                                    id_patient={id_patient}
                                    menuPortalTarget={document.body}
                                // menuPosition="fixed"

                                />
                            </div>
                        }

                        {checkTypeClient === 3 && (
                            <>
                                <div className="select-container">
                                    <Select
                                        classNamePrefix='select-pill'
                                        name="id_company"
                                        value={id_company}
                                        options={listCompanies}
                                        onChange={(e) => handleChangeClient(e)}
                                        placeholder="Seleccione una empresa"
                                        styles={customSelectStyles}
                                    />
                                </div>
                                {
                                    !isEditWorkOrder && <div className="select-container">
                                        <Select
                                            classNamePrefix='select-pill'
                                            name="idAgreementCompany"
                                            options={listAgreements}
                                            value={idAgreementCompany}
                                            onChange={(e) => handleChangeAgreement(e)}
                                            placeholder="Seleccione un convenio"
                                            styles={customSelectStyles}
                                        />
                                    </div>
                                }


                            </>
                        )}
                        <div className="search-container">
                            <GlobalSearchAdmission
                                handleChangePatient={handleChangePatient}
                                handleChangeDoctor={handleChangeDoctor}
                                idDoctorSelect={idDoctorSelect}
                                handleSelectExamChange={handleSelectExamChange}
                                id_patient={id_patient}
                                handleCreateDoctor={handleCreateDoctor}
                                handleCreatePatient={handleCreatePatient}
                                isEditWorkOrder={isEditWorkOrder}
                                _config_dashboard={_config_dashboard}
                                validate_actions={validate_actions}
                                allExams={allExams}
                                loadingEditWorkOrder={loadingEditWorkOrder}
                                checkTypeClient={checkTypeClient}
                                id_company={id_company}
                                idAgreementCompany={idAgreementCompany}
                            />
                        </div>

                    </div>
                </Col>



                <Col xs="12" lg="auto" className="d-flex justify-content-end pl-0 header-block header-menu mobile-only">
                    <div
                        className="icon-toggle"
                        onClick={() => setRightPanelOpen(!rightPanelOpen)}
                    >
                        <i className="fa fa-bars"></i>
                    </div>
                </Col>
            </Row >

            {/* MOBILE HEADER */}
            <Row className="mobile-header-row">
                {/* Type */}
                <Col xs="2" className="mobile-top-actions pr-0 pt-2">
                    <div
                        className={`icon-toggle mobile-type-toggle ${showMobileFilters ? "active" : ""}`}
                        onClick={() => setShowMobileFilters(!showMobileFilters)}
                        title={currentMobileType.title}
                    >
                        <i className={currentMobileType.icon}></i>
                    </div>
                </Col>

                {/* SEARCH */}
                <Col xs="9">
                    <div className="search-container">
                        <GlobalSearchAdmission
                            handleChangePatient={handleChangePatient}
                            handleChangeDoctor={handleChangeDoctor}
                            idDoctorSelect={idDoctorSelect}
                            handleSelectExamChange={handleSelectExamChange}
                            id_patient={id_patient}
                            handleCreateDoctor={handleCreateDoctor}
                            handleCreatePatient={handleCreatePatient}
                            isEditWorkOrder={isEditWorkOrder}
                            _config_dashboard={_config_dashboard}
                            validate_actions={validate_actions}
                            allExams={allExams}
                            loadingEditWorkOrder={loadingEditWorkOrder}
                            id_company={id_company}
                            idAgreementCompany={idAgreementCompany}
                            checkTypeClient={checkTypeClient}

                        />
                    </div>
                </Col>

                {/* ICONS */}
                <Col xs="1" className="mobile-top-actions pr-0 pt-2">
                    <div
                        className="icon-toggle f-20"
                        onClick={() => setRightPanelOpen(!rightPanelOpen)}
                    >
                        <i className="fa fa-bars"></i>
                    </div>

                </Col>

            </Row>
            {
                showMobileFilters && (
                    <div className="mobile-extra-options">

                        {!isEditWorkOrder && (
                            <div className="mobile-field row mx-0">
                                <div className={mobileCol}>

                                    <Button
                                        size="sm"
                                        onClick={() => handleChangeTypeClient(1)}
                                        className={`pos-pill w-100 ${checkTypeClient === 1 ? "active" : ""}`}
                                    >
                                        <i className="icofont icofont-user-alt-5 f-16"></i>
                                        &nbsp; Particular
                                    </Button>
                                </div>

                                {
                                    (url_helen !== buap && checkTypeClient !== 2) && (
                                        <div className={mobileCol}>
                                            <Button
                                                size="sm"
                                                onClick={() => handleChangeTypeClient(3)}
                                                className={`pos-pill w-100 ${checkTypeClient === 3 ? "active" : ""}`}
                                            >
                                                <i className="icofont icofont-industries-alt-4 f-16"></i>
                                                &nbsp; Empresa
                                            </Button>
                                        </div>
                                    )
                                }

                                {
                                    (url_helen === buap && checkTypeClient !== 3) &&
                                    <div className={mobileCol}>

                                        <Button
                                            size="sm"
                                            onClick={() => handleChangeTypeClient(2)}
                                            className={`pos-pill w-100 ${checkTypeClient === 2 ? "active" : ""}`}
                                        >
                                            <i className="icofont icofont-users-social f-16"></i>
                                            &nbsp; Muestreo
                                        </Button>
                                    </div>

                                }

                            </div>
                        )}

                        {isEditWorkOrder && (
                            <div className="mobile-field d-flex gap-2 align-items-center">

                                <button className="pos-pill active" disabled>
                                    {checkTypeClient === 1 ? "Particular" : "Empresa"}
                                </button>

                                <button
                                    className="wo-mini-btn back"
                                    onClick={() => history.goBack()}
                                    disabled={loadingEditWorkOrder}
                                >
                                    <i className="pi pi-arrow-left"></i>
                                </button>

                            </div>
                        )}

                        {/* <div className="mobile-field">
                            <Select
                                classNamePrefix="select-pill"
                                styles={customSelectStyles}
                                value={id_printer_point}
                                options={listPrinterPoint}
                                onChange={(e) =>
                                    handleSelectValuesWorkOrder(e, "id_printer_point")
                                }
                                placeholder={PlaceHolderOption}
                                isClearable
                            />
                        </div> */}

                        {validHopitalInterfaced === "True" && (
                            <div className="mobile-field">
                                <Select
                                    classNamePrefix="select"
                                    value={id_work_order_type_service}
                                    options={listType}
                                    onChange={(e) =>
                                        handleSelectValuesWorkOrder(
                                            e,
                                            "id_work_order_type_service"
                                        )
                                    }
                                    styles={customSelectStyles}
                                />
                            </div>
                        )}

                        {checkTypeClient === 3 && (
                            <>
                                <div className="mobile-field">
                                    <Select
                                        classNamePrefix='select-pill'
                                        name="id_company"
                                        value={id_company}
                                        options={listCompanies}
                                        onChange={(e) => handleChangeClient(e)}
                                        placeholder={PlaceHolderOption}
                                        styles={customSelectStyles}
                                    />
                                </div>

                                <div className="mobile-field">
                                    {
                                        !isEditWorkOrder &&
                                        <Select
                                            classNamePrefix='select-pill'
                                            name="idAgreementCompany"
                                            options={listAgreements}
                                            value={idAgreementCompany}
                                            onChange={(e) => handleChangeAgreement(e)}
                                            placeholder={PlaceHolderOption}
                                            styles={customSelectStyles}
                                        />
                                    }
                                </div>
                            </>
                        )}

                    </div>
                )
            }

        </>
    )
}
